




































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { OrderResp, File, Timestamp } from '@/apiv3/index'
import formatter from '@/helpers'
import auth from '@/auth'

@Component({ components: { PulseLoader } })
export default class Order extends Vue {
  @Prop(String) id!: string

  public loaded = false
  public order: OrderResp | null = null

  mounted (): void {
    auth.userClient().Order({ id: BigInt(this.getID(this.id)) }).then((resp) => {
      this.order = resp
    }).finally(() => {
      this.loaded = true
    })
  }

  getID (val: string): number {
    const id = Number.parseInt(val, 10)
    if (Number.isNaN(id)) {
      return 1
    }

    return id
  }

  formatDateOnly (val: Timestamp | undefined): string {
    return formatter.formatDateOnlyTs(val)
  }

  public getFileURL (file: File, ord: OrderResp | null): string {
    return formatter.getFileURL(file, ord)
  }
}
